"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _Box = _interopRequireDefault(require("../Box/Box"));

var Text = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Text",
  componentId: "sc-1j75xd-0"
})(["", " ", " ", " ", " ", ""], _styledSystem.fontFamily, _styledSystem.fontWeight, _styledSystem.textAlign, _styledSystem.lineHeight, _styledSystem.letterSpacing);
Text.propTypes = (0, _extends2["default"])({}, _Box["default"].propTypes, {}, _styledSystem.fontFamily.propTypes, {}, _styledSystem.textAlign.propTypes, {}, _styledSystem.lineHeight.propTypes, {}, _styledSystem.letterSpacing.propTypes, {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
});
Text.defaultProps = {
  fontFamily: "sansSerif",
  color: "dark.1",
  as: "span"
};
var _default = Text;
exports["default"] = _default;